import React, {useState, useEffect, useRef} from 'react'
import apiClient from '../api/apiClient.js'
import NameOnUploadModal from '../components/NameOnUploadModal'
import {useAuth} from '../context/AuthContext'
import './StaffPage.css'
import './StudentClassStudentAdminPage.css'
import './UploadExams.css'


export default function UploadExams(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [currentTestGroupAssignedStudents, setCurrentTestGroupAssignedStudents] = useState([])
    const [droppedFiles, setDroppedFiles] = useState([])
    const [isDragOver, setIsDragOver] = useState(false)
    const [nameOnUploadModal, setNameOnUploadModal] = useState(false)
    const [files, setFiles] = useState([])
    const [studentsWithExams, setStudentsWithExams]= useState([])
    
    const [searchTerm, setSearchTerm] = useState('')
    const [currentTestType, setCurrentTestType] = useState('ALLE')
    const [displayTestGroups, setDisplayTestGroups] = useState([])
    const [isPublishing, setIsPublishing] = useState(false)
    const fileInputRef = useRef(null)

    async function fetchTestGroups(){
        try{
            const result = await apiClient.get('/api/testgroup/getall', 
                {params : {schoolID: schoolID}}
            )
            setTestGroups(result.data)
            return result.data
        }catch(e){
            console.log("fejl ved fetch af test groups")
            console.log(e)
            return []
        }
    }



    async function fetchTestGroupStudents(){
        try{            
            console.log(` id er ${currentTestGroup.id}`)
            
            const result = await apiClient.get('/api/testgroup/getselectablestudents', 
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
/*            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup', 
                {params: {testGroupID: currentTestGroup?.id || null}}
            )*/
            setCurrentTestGroupAssignedStudents(result.data)
        }catch(e){
            console.log("fejl ved kald af fetch test group")
            console.log(e)
        }
    }

    async function fetchStudentsWithExams(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentswithexams',
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
            setStudentsWithExams(result.data)
            setDisplayTestGroups(result.data)

            //console.log(result.data)
        }catch(e){
            console.log(" error in getting students with exams")
            console.log(e)
        }
    }

    function handleDragOver(e){
        e.preventDefault()
        setIsDragOver(true)
    }

    function handleDragLeave(e){
        e.preventDefault()
        setIsDragOver(false)
    }

    async function handleDrop(e){
        e.preventDefault()
        setIsDragOver(false)
        if(currentTestGroup === null)
            return
        
        setNameOnUploadModal(true)
        setFiles(Array.from(e.dataTransfer.files).filter(
            f => f.type === 'application/pdf'
        ))

    }

    function handleDropZoneClick() {
        if (currentTestGroup === null) return
        fileInputRef.current?.click()
    }

    function handleFileInputChange(e) {
        const input = e.target
        if (currentTestGroup === null) {
            input.value = ''
            return
        }
        const picked = Array.from(input.files || []).filter(
            (f) => f.type === 'application/pdf'
        )
        input.value = ''
        if (picked.length === 0) return
        setNameOnUploadModal(true)
        setFiles(picked)
    }

/*     function removeFile(index){
        setDroppedFiles(prev => prev.filter((_, i) => i !== index))
    } */

/*     useEffect(()=>{
        fetchTestGroupStudents()
        fetchStudentsWithExams()
    }, [currentTestGroup, nameOnUploadModal]) */

    useEffect(()=>{
        fetchTestGroups()
    }, [schoolID])
    
    useEffect(()=>{

        const filteredTestGroupArray = testGroups.filter(tg => 
            {
                if(!(tg.studie === currentTestType || currentTestType ==='ALLE')) return false;
                const haystack = 
                (tg.navn+tg.studie+tg.eksaminator_initialer+tg.eksaminator_fornavn+tg.eksaminator_efternavn+
                tg.censor_fornavn+tg.censor_efternavn).toLowerCase()
                if(!haystack.includes(searchTerm.toLowerCase())) return false;
                return true;
            })    
        setDisplayTestGroups(filteredTestGroupArray)
    }, [testGroups, currentTestType, searchTerm, currentTestGroup, nameOnUploadModal])


    async function handleNameUpload(params){
        const {studentID, testGroupID} = params;
        console.log(`fil upload ${studentID}, ${testGroupID}` )
        if(files?.length > 0){
            console.log("uploading file")
        
            try{

                // note if upload to testgroup, the studentID is null
                const formData = new FormData()
                formData.append('file', files[0])
                formData.append('studentID', studentID)
                formData.append('testGroupID', testGroupID)
                const result = await apiClient.post('/api/uploadfile', formData, {
                    headers: {'Content-Type': 'multipart/form-data'},
                    timeout: 120000
                })

                //refresh and re-link to re-load test group
                const fresh = await fetchTestGroups()
                if(currentTestGroup){
                    setCurrentTestGroup(fresh.find(s=> s.id === currentTestGroup.id) || null)
                }

            }catch(e){
                console.log("fejl ved fil upload")
                console.log(e)
            }
            setDroppedFiles(prev => [...prev, ...files])
        }
    
        //                handleNameUpload({studentID: selectedStudent.id, testGroupID: testGroupID})

    }

    async function handleDownload(thisFilename){
        try{
            const result = await apiClient.get('/api/downloadfile', {
                params: {filename: thisFilename}, 
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(result.data)
            const a = document.createElement('a')
            a.href = url
            a.download = thisFilename
            a.click()
            window.URL.revokeObject(url)
        }catch(e){
            console.log("fejl ved download af " + thisFilename)
            console.log(e)
        }
    }

    async function handleRemoveFile({fileName, testGroupId, studentId}){
        try{
            await apiClient.post('/api/removefile', {filename: fileName, testGroupId: testGroupId, studentId: studentId})
            
            const freshTestGroups = await fetchTestGroups()
            if(currentTestGroup){
                setCurrentTestGroup(freshTestGroups.find(tg=> tg.id === currentTestGroup.id)|| null)
            }


        }catch(e){
            console.log("fejl ved fjernelse af fil")
            console.log(e)
        }
    }

    async function performPublication(){
        setIsPublishing(true)
        try{
            await apiClient.post('/api/testgroup/publicizetestgroup', {
                testGroupID: currentTestGroup.id
            } )
            setCurrentTestGroup({...currentTestGroup, publiceret: true})
            alert(`Eksaminator og censor for prøvegruppe: ${currentTestGroup.navn}
er orienteret om uploadede prøver via email.`)
        }catch(e){
            console.log("error raised for publicizing test group" +currentTestGroup.id)
            console.log(e)
            alert(`Kunne ikke orientere eksaminator og censor for prøvegruppe: ${currentTestGroup.navn}.
Prøv igen, eller kontakt support hvis problemet fortsætter.`)
        }finally{
            setIsPublishing(false)
        }
    }

    return(
        <div className="panel-container upload-exams-page">
            <div className="panel">
                <div className="table-bar">
                    <input 
                        type="text"
                        className="search-input"
                        placeholder="Søg..."
                        value={searchTerm}
                        onChange={(e)=>setSearchTerm(e.target.value)}
                    />
                    <select
                        value={currentTestType}
                        onChange={(e) =>setCurrentTestType(e.target.value)}
                        aria-label="Filtrér efter prøvetype"
                    >
                        <option key="ALLE" value="ALLE">Alle</option>
                        <option key="PD1" value="PD1">PD1</option>
                        <option key="PD2" value="PD2">PD2</option>
                        <option key="PD3" value="PD3">PD3</option>
                    </select>
                </div>
{/*                 <select onChange={(e) => setCurrentTestGroup(testGroups.find(s=> s.id === parseInt(e.target.value)))}>
                    <option key="0" value={null}>Ingen prøvegruppe valgt</option>
                    {testGroups.map(testGroup=>{
                        return(
                            <option key={testGroup.id} value={testGroup.id}>{testGroup.navn}</option>
                        )
                    })}
                </select> */}


                <table className="censor-table">
                        <thead>
                            <tr>
                                <th>Navn</th>
                                <th>Prøvetype</th>
                                <th>Eksaminator</th>
                                <th>Censor</th>
                            </tr>
                        </thead>
                        <tbody>
                        {displayTestGroups.length === 0 ? 
                            (
                                <tr>
                                    <td colSpan={4} className="drop-zone-hint">Ingen prøvegrupper</td>
                                </tr>
                            ):(
                                displayTestGroups.map(pg=>{
                                   const isSelected = currentTestGroup?.id === pg.id
                                   return(
                                        <tr
                                            key={pg.id}
                                            className={`upload-row-selectable ${isSelected ? 'upload-row-selected' : ''}`}
                                            onClick={()=>setCurrentTestGroup(pg)}
                                        >
                                            <td>{pg.navn}</td><td>{pg.studie}</td>
                                            <td>{pg.eksaminator_initialer && '('+pg.eksaminator_initialer+')'} {pg.eksaminator_fornavn} {pg.eksaminator_efternavn}</td>
                                            <td>{pg.censor_fornavn} {pg.censor_efternavn}</td>
                                        </tr>
                                    )})
                            )
                        }    
                        </tbody>
                </table>
            </div>
            <div className="panel">
                <span className="panel-text">
                    <b>Testgruppe: </b>{currentTestGroup?.navn ?? '—'} 
                </span>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,application/pdf"
                    style={{ display: 'none' }}
                    aria-hidden="true"
                    tabIndex={-1}
                    onChange={handleFileInputChange}
                />
                <div
                    role="button"
                    tabIndex={currentTestGroup ? 0 : -1}
                    aria-disabled={!currentTestGroup}
                    onClick={handleDropZoneClick}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            handleDropZoneClick()
                        }
                    }}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`upload-drop-zone${isDragOver ? ' upload-drop-zone--active' : ''}${currentTestGroup ? '' : ' upload-drop-zone--inactive'}`}
                >   
                    <p>
                        Træk PDF-filer hertil, eller klik for at vælge fil
                    </p>
                </div>
                <span className="upload-section-title">
                    Besvarelser uploaded til testgruppen
                </span>
                {!currentTestGroup?.examupload_filenames?.length ? (
                    <p className="upload-muted">Ingen filer uploadet</p>
                ):(
                    <>
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th>Filnavn</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentTestGroup?.examupload_filenames?.map(file => (
                                <tr key={file}>
                                    <td>
                                        <div className="upload-file-name">{file}</div>
                                        <div className="upload-file-actions">
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={() => handleRemoveFile({fileName: file, testGroupId: currentTestGroup.id})}
                                            >
                                                Fjern
                                            </button>
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={() => handleDownload(file)}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="upload-publish-row">
                        {currentTestGroup?.publiceret ? (
                            <p className="upload-muted">Testgruppens indhold er publiceret. Nye upload stadig mulig.</p>
                        ):(
                            <button type="button" className="action-btn" disabled={isPublishing} onClick={()=>performPublication()}>{isPublishing ? 'Sender…' : 'Orienter eksaminator og censor'}</button>
                        )}
                    </div>
                    </>
                )}

                {studentsWithExams.length > 0 && (
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th>Fornavn</th>
                                <th>Efternavn</th>
                                <th>Filnavn</th>
                                <th>Handling</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentsWithExams.map(student => (
                                <tr key={student.id}>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavne}</td>
                                    <td>
                                        <div className="upload-file-name">{student.examupload_filename}</div>
                                    </td>
                                    <td>
                                        <div className="upload-file-actions">
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={() => console.log("file not removed. this is just a console.log")}
                                            >
                                                Fjern
                                            </button>
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={()=> handleDownload(student.examupload_filename)}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            { nameOnUploadModal &&
                <NameOnUploadModal 
                    testGroupID = {currentTestGroup.id}
                    handleNameUpload = {handleNameUpload}
                    onClose ={()=> setNameOnUploadModal(false)} 
                />                
            }
        </div>
    )
}